export default __webpack_public_path__ + "static/media/34.611cb2f9.jpg";